import { Divide as Hamburger } from "hamburger-react";
// import { useState } from "react";
import Sidebar from "./Sidebar";
import useMenu from "../Hooks/menuContext";

function Navbar() {
  const {open, setOpen} = useMenu();
  return (
    <div>
      <div className="nav">
        <Hamburger  onClick={()=>setOpen(open ===!open)} toggled={open}  toggle={setOpen} duration={1} />
        <h4>
          lameck_meshack()<span>;</span>
        </h4>
      </div>
      {open && <Sidebar />}
    </div>
  );
}

export default Navbar;
